import 'rxjs/add/operator/debounceTime';
import {Component, ElementRef, ViewChild} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {DataService} from "../../../providers/data-service";
import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {NavRepository} from "../../../repositories/nav-repository";

@Component({
    selector: 'page-profile-ship',
    templateUrl: 'profile-ship.html',
    providers: [ProfileService]
})
export class ProfileShipPage {

    @ViewChild('compra01') compra01: ElementRef;
    @ViewChild('compra02') compra02: ElementRef;
    @ViewChild('compra03') compra03: ElementRef;
    @ViewChild('compra04') compra04: ElementRef;

    etapa: number;
    config: any;
    logado: any;
    rootile: any;
    copyile: any;

    handlerStep: number;
    messageStep: number = 1;
    pluspay: number = 1;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public util: Util, public logadoService: LogadoService,
                public profileService: ProfileService,
                public dataService: DataService, public navRepository: NavRepository) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.etapa = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');
        this.copyile = this.navParams.get('copyile');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Menu', '/profile-menu');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

        if (this.etapa == 0) {
            //Inicia Carrocel
            this.animateShow(false);
            setTimeout(() => this.animateNext(), 2000);
        }

    }

    animateShow(info) {

        clearTimeout(this.handlerStep);

        //Inicia Carrocel
        this.messageStep = (info ? 0 : 1);
        if (!info) this.handlerStep = setInterval(() => this.animateNext(), 5000);

    }

    animateNext() {

        if (this.messageStep == 1) this.compra01.nativeElement.style.animation = 'fadeOut 2s';
        if (this.messageStep == 2) this.compra02.nativeElement.style.animation = 'fadeOut 2s';
        if (this.messageStep == 3) this.compra03.nativeElement.style.animation = 'fadeOut 2s';
        if (this.messageStep == 4) this.compra04.nativeElement.style.animation = 'fadeOut 2s';

        let step = (this.messageStep == 4 ? 1 : this.messageStep + 1);

        let onStep = (compraXX) => {
            if (compraXX) compraXX.nativeElement.style.animation = 'fadeInDownBig 1s';
        };

        setTimeout(() => {
            this.messageStep = step;
            if (step == 2) setTimeout(() => onStep(this.compra02));
            if (step == 3) setTimeout(() => onStep(this.compra03));
            if (step == 4) setTimeout(() => onStep(this.compra04));
            if (step == 1) setTimeout(() => onStep(this.compra01));
        }, 1000);

    }

    getTitle() {

        if (this.etapa == 0) return '';

    }



    profileTime(timepay) {

        this.util.impact();
        this.pluspay = timepay;

    }

    dismiss() {

        this.messageStep = 0;
        clearTimeout(this.handlerStep);

        this.viewCtrl.dismiss();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/profile-ship/profile-ship.ts